module.exports = __webpack_public_path__ + "img/8x8.56a82fa3.png";